<template>
  <vue-page-transition name="fade-in-down">
    <v-content class="bg-content-ai">
<div
class="ai-assistant-panel"
:class="{
  'listening-bg': isListening,
  'speaking-bg': isSpeaking,
  'thinking-bg': isThinking,
}"
>
<!-- 🔔 Toast Notification -->
<div v-if="showToast" class="ai-toast">
{{ toastMessage }}
</div>

  <div class="avatar">
    
    <img
      :class="{ listening: isListening, thinking: isThinking }"
      src="@/assets/UI2.gif"
      alt="AI Avatar"
    />
    <h3 style="margin-top: -20px;">AI Tour Analyst</h3>
    <div class="progress-bar-ui">
<!-- <p class="progress-label">🔄 Progress Tracker</p> -->

</div>

  </div>
  <div v-if="userTranscript" class="transcript-box">
  <strong>You said:</strong> "{{ userTranscript }}"
</div>
<!-- Progress Bar -->
<div class="progress-bar-container">
  <div class="progress-bar" :style="{ width: progressPercent + '%' }"></div>
  <span class="progress-text">{{ progressPercent }}%</span>
</div>
<br />
<div class="chat-log-ui">
<!-- <p class="chat-header">🤖 AI Execution Tracker</p> -->
<div class="chat-log">
  <p
    v-for="(step, i) in steps"
    :key="i"
    :class="{ active: !step.done, completed: step.done }"
  >
    <span class="status-icon">
      <span v-if="step.done">✅</span>
      <span v-else>⏳</span>
    </span>
    {{ step.label }}
  </p>
</div>
</div>
<div class="interaction">
  <!-- <p class="ai-question">🎤 What artist do you want to research?</p> -->
  <input
    v-model="artistInput"
    placeholder="Say or type artist name..."
    @input="fetchArtistSuggestions"
    @keyup.enter="submitArtist"
  />
  <ul v-if="artistSuggestions.length" class="suggestion-list">
    <li
      v-for="artist in artistSuggestions"
      :key="artist.id"
      @click="selectArtist(artist)"
    >
      {{ artist.name }}
    </li>
  </ul>
  <div class="button-row">
    <button @click="startListening">
      {{ isListening ? "Listening..." : "🎙 Voice Input" }}
    </button>
    <button @click="submitArtist">Search</button>
  </div>
</div>

<div class="step-toggle-ui">
<p class="ai-question">✅ What steps should I run?</p>
<div class="checkbox-list">
  <label v-for="step in stepOptions" :key="step">
    <input type="checkbox" :value="step" v-model="selectedSteps" />
    <span class="tracker"></span>
    {{ step }}
  </label>
</div>
</div>

<div v-if="showIframe" class="iframe-controls">
<button v-if="!isFullscreen" @click="toggleFullscreen">🔎 Expand Fullscreen</button>
<button v-if="isFullscreen" @click="toggleFullscreen">❌ Exit Fullscreen</button>
</div>

<iframe
v-if="showIframe"
:src="iframeUrl"
:class="{ 'fullscreen-iframe': isFullscreen }"
class="ai-iframe"
></iframe>
<!-- <div v-if="isThinking" class="thinking">
  <p>🤖 Thinking...</p>
  <img src="@/assets/UI2.gif" alt="Thinking" />
</div>
<div v-if="isSpeaking" class="speaking">
  <p>🔊 Speaking...</p>
  <img src="@/assets/UI2.gif" alt="Speaking" />
</div> -->
<br />
<br />
</div>  
<br />
<br />
</v-content>

  </vue-page-transition>
</template>

<script>
import axios from "axios";

export default {
data() {
return {
artistInput: "",
  currentStep: 0,
  isListening: false,
  isSpeaking: false,
  isThinking: false,
  recognition: null,
  artistSuggestions: [],
  spotifyToken: "",
  userTranscript: "",
  toastMessage: '',
  isFullscreen: false,
showToast: false,
progressPercent: 0,
  readOutLoudReady: false,
  artistGallery: [],
  steps: [
    { label: "Artist received", done: false },
    { label: "Spotify data", done: false },
    { label: "Ticketmaster data", done: false },
    { label: "AI prediction", done: false },
    { label: "Finalizing results", done: false },
  ],
  stepOptions: ["map", "report", "analysis", "chart"],
  selectedSteps: ["map", "report"],
  iframeUrl: "",
  showIframe: false,
};
},
created() {
// ✅ Ensure voices are loaded before using speech synthesis
window.speechSynthesis.onvoiceschanged = () => {
  this.readOutLoudReady = true;
};
},
mounted() {
this.listenForYes();
  setTimeout(() => {
    const message = "Answer yes or no to confirm tbe artist.";
this.readOutLoud(message);
this.showToastMessage(message);
}, 2000);
setTimeout(() => {
    const message = "Listening for your input.";
this.readOutLoud(message);
this.showToastMessage(message);

  this.startListening();
}, 5000);
setTimeout(() => {
  this.startListening2();
  this.showToastMessage(`You selected ${this.artistInput}`);
}, 6000);
setTimeout(() => {

  this.listenForConfirmation();
}, 8000);
// Ensure the parent can access this instance
this.$emit("register-assistant-ref", this);
},
methods: {
  toggleFullscreen() {
this.isFullscreen = !this.isFullscreen;
},

    async getSpotifyToken() {
try {
const response = await axios.post(
  "https://accounts.spotify.com/api/token",
  new URLSearchParams({
    grant_type: "client_credentials",
    client_id: "1522ec4d96914840aef42817fe1b387b",
    client_secret: "673c7686457a438488401835249dca6b",
  }),
  {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  }
);
return response.data.access_token;
} catch (error) {
console.error("Error fetching Spotify access token:", error);
}
},
async fetchArtistSuggestions() {
if (!this.artistInput) return;
if (!this.spotifyToken) this.spotifyToken = await this.getSpotifyToken();

try {
const response = await axios.get(
  `https://api.spotify.com/v1/search?q=${encodeURIComponent(this.artistInput)}&type=artist&limit=5`,
  {
    headers: {
      Authorization: `Bearer ${this.spotifyToken}`,
    },
  }
);
this.artistSuggestions = response.data.artists?.items || [];
} catch (error) {
console.error("Error fetching suggestions:", error);
}
},


selectArtist(artist) {
this.artistInput = artist.name;
this.artistSuggestions = [];
this.submitArtist();
},
submitArtist() {
if (!this.artistInput) return;
this.steps[0].done = true;
this.isThinking = true;

const message = `Searching for artist ${this.artistInput}`;
this.readOutLoud(message);
this.showToastMessage(message);

this.$emit("artist-submitted", this.artistInput);
this.runSteps();
},
// runSteps() {
//   let delay = 1500;
//   const stepMessages = [
//     `✅ Artist received. Now fetching Spotify data.`,
//     `🔍 Getting Spotify data...`,
//     `🎟 Loading events from Ticketmaster, Setlist.fm, and Bandsintown.`,
//     `🧠 Running AI tour prediction and analysis.`,
//     `🗺 Finalizing map and results. Almost done!`,
//   ];

//   this.steps.forEach((step, index) => {
//     setTimeout(() => {
//       this.steps[index].done = true;
//       this.currentStep++;

//       const msg = stepMessages[index];
//       this.readOutLoud(msg);

//       if (index === this.steps.length - 1) {
//         this.isThinking = false;
//         const artistName = this.artistInput || "unknown";
//         const stepsQuery = this.selectedSteps.join(",");
//         this.iframeUrl = `/artisttoursanalyst?artistInput=${encodeURIComponent(artistName)}&steps=${encodeURIComponent(stepsQuery)}`;
//         this.showIframe = true;
//       }
//     }, delay * (index + 1));
//   });
// },
// runSteps() {
//   let delay = 1500;
//   const stepMessages = [
//     `✅ Artist received. Now fetching Spotify data.`,
//     `🔍 Getting Spotify data...`,
//     `🎟 Loading events from Ticketmaster, Setlist.fm, and Bandsintown.`,
//     `🧠 Running AI tour prediction and analysis.`,
//     `🗺 Finalizing map and results. Almost done!`,
//   ];

//   this.steps.forEach((step, index) => {
//     setTimeout(() => {
//       this.steps[index].done = true;
//       this.currentStep++;

//       const msg = stepMessages[index];
//       this.readOutLoud(msg);
//       this.showToastMessage(msg);

//       // Progress % (e.g., 20% per step)
//       this.progressPercent = Math.round(((index + 1) / this.steps.length) * 100);

//       if (index === this.steps.length - 1) {
//         this.isThinking = false;
//         const artistName = this.artistInput || "unknown";
//         const stepsQuery = this.selectedSteps.join(",");
//         this.iframeUrl = `/artisttoursanalyst?artistInput=${encodeURIComponent(artistName)}&steps=${encodeURIComponent(stepsQuery)}`;
//         this.showIframe = true;
//       }
//     }, delay * (index + 1));
//   });
// },
listenForYes() {
  window.addEventListener("keydown", (event) => {
    if (event.key.toLowerCase() === "y") {
      this.completeFirstStep();
    }
  });
},
completeFirstStep() {
  if (!this.steps[0].done) {
    this.steps[0].done = true;
    this.showToastMessage("✅ Artist received");
    this.runSteps();
  }
},
runSteps() {
  let delay = 1500;
  const stepMessages = [
    `Artist received`,
    `Spotify data`,
    `Ticketmaster data`,
    `AI prediction`,
    `Finalizing results`,
  ];

  this.steps.forEach((step, index) => {
    setTimeout(() => {
      if (!this.steps[index].done) {
        this.steps[index].done = true;
        this.currentStep++;
        this.readOutLoud("Searching Online...");
        this.showToastMessage(stepMessages[index]);
        this.progressPercent = Math.round(((index + 1) / this.steps.length) * 100);
      }

      if (index === this.steps.length - 1) {
        this.isThinking = false;
        const artistName = this.artistInput || "unknown";
        const stepsQuery = this.selectedSteps.join(",");
        this.iframeUrl = `/artisttoursanalyst?artistInput=${encodeURIComponent(artistName)}&steps=${encodeURIComponent(stepsQuery)}`;
        this.showIframe = true;
      }
    }, delay * (index + 1));
  });
},

showToastMessage(msg) {
  console.log(msg); // Replace with actual toast implementation
  this.toastMessage = msg;
  this.showToast = true;
  setTimeout(() => {
    this.showToast = false;
  }, 3000);
},
startListening() {
if (!("webkitSpeechRecognition" in window)) {
alert("Speech recognition not supported in this browser.");
return;
}
setTimeout(() => {
  this.listenForConfirmation(this.artistInput);
}, 6000);
const SpeechRecognition = window.webkitSpeechRecognition;
this.recognition = new SpeechRecognition();
this.recognition.lang = "en-US";
this.recognition.interimResults = false;
this.recognition.maxAlternatives = 1;

this.recognition.onstart = () => {
this.isListening = true;
};

this.recognition.onresult = (event) => {
const transcript = event.results[0][0].transcript.trim();
this.artistInput = transcript;
this.userTranscript = transcript;
this.playChime(); // ✅ sound cue
this.isListening = false;
this.readOutLoud(`You said ${transcript}. Should I continue? Say yes or no.`);
setTimeout(() => this.listenForConfirmation(transcript), 6500);
};

this.recognition.onerror = () => {
this.isListening = false;
};

this.recognition.onend = () => {
this.isListening = false;
};

this.recognition.start();
},
startListening2() {
if (!("webkitSpeechRecognition" in window)) {
alert("Speech recognition not supported in this browser.");
return;
}

const params = new URLSearchParams(window.location.search);
const artistFromURL = params.get("artistInput");

if (artistFromURL) {
this.artistInput = decodeURIComponent(artistFromURL);
this.playChime(); // ✅ sound cue
setTimeout(() => {
  this.readOutLoud(`You selected ${this.artistInput}.`);
  this.showToastMessage(`You selected ${this.artistInput}.`);
  this.listenForConfirmation(this.artistInput);
}, 6000);
setTimeout(() => {
  this.readOutLoud(`Choose from Map, Report, Analysis or Chart.`);
  this.showToastMessage(`Choose from Map, Report, Analysis or Chart.`);
}, 7000);
setTimeout(() => {
    this.listenForConfirmation(this.artistInput);
  }, 8000);
return; // ✅ Exit early so speech recognition doesn't trigger
}

const SpeechRecognition = window.webkitSpeechRecognition;
this.recognition = new SpeechRecognition();
this.recognition.lang = "en-US";
this.recognition.interimResults = false;
this.recognition.maxAlternatives = 1;

this.recognition.onstart = () => {
this.isListening = true;
};

this.recognition.onresult = (event) => {
const transcript = event.results[0][0].transcript.trim();
this.artistInput = transcript;
this.userTranscript = transcript;
this.playChime(); // ✅ sound cue
this.isListening = false;
this.readOutLoud(`You said ${transcript}. Should I continue? Say yes or no.`);
setTimeout(() => this.listenForConfirmation(transcript), 3500);
};

this.recognition.onerror = () => {
this.isListening = false;
};

this.recognition.onend = () => {
this.isListening = false;
};

this.recognition.start();
},
// ✅ Listen for confirmation    

// listenForConfirmation(artistName) {
//       this.recognition.onresult = (event) => {
//         const confirmation = event.results[0][0].transcript.trim().toLowerCase();
//         this.userTranscript = confirmation;
//         this.isListening = false;
//         this.playChime(); // ✅ sound cue
//         if (confirmation.includes("yes")) {
//           this.readOutLoud(
//             `Great! Which steps would you like me to take? You can say map, report, analysis or chart.`
//           );
//           setTimeout(() => this.listenForStepSelection(artistName), 4000);
//           // this.submitArtist();
//         } else {
//           this.readOutLoud(`Okay, canceled request for ${artistName}.`);
//         }
//       };
//       this.recognition.start();
//     },
//     listenForStepSelection(artistName) {
//       this.recognition.onresult = (event) => {
//         const spoken = event.results[0][0].transcript.toLowerCase();
//         this.userTranscript = spoken;
//         this.selectedSteps = this.stepOptions.filter((step) => spoken.includes(step));
//         if (!this.selectedSteps.length) {
//           this.readOutLoud("I didn't understand the steps. Please try again.");
//           return;
//         }
//         this.readOutLoud(`Starting steps: ${this.selectedSteps.join(", ")} for ${artistName}`);
//         this.submitArtist();
//       };
//       this.recognition.start();
//     },

listenForConfirmation(artistName) {
this.recognition.onresult = (event) => {
const confirmation = event.results[0][0].transcript.trim().toLowerCase();
this.userTranscript = confirmation;
this.isListening = false;
this.playChime();

if (confirmation.includes("yes")) {
  // const message = `Great! Which steps would you like me to take? You can say map, report, analysis or chart.`;
  // this.readOutLoud(message);
  // this.showToastMessage(message);
  setTimeout(() => this.listenForStepSelection(artistName), 4000);
} else {
  const cancelMsg = `Okay, canceled request for ${artistName}.`;
  this.readOutLoud(cancelMsg);
  this.showToastMessage(cancelMsg);
}
};
this.recognition.start();
},

listenForStepSelection(artistName) {
this.recognition.onresult = (event) => {
const spoken = event.results[0][0].transcript.toLowerCase();
this.userTranscript = spoken;
this.selectedSteps = this.stepOptions.filter((step) => spoken.includes(step));

if (!this.selectedSteps.length) {
  const errorMsg = "I didn't understand the steps. Please try again.";
  this.readOutLoud(errorMsg);
  this.showToastMessage(errorMsg);
  return;
}

const successMsg = `Starting steps: ${this.selectedSteps.join(", ")} for ${artistName}`;
this.readOutLoud(successMsg);
this.playChime();
this.showToastMessage(successMsg);

this.submitArtist();
};
this.recognition.start();
},
readOutLoud(msg) {
const speech = new SpeechSynthesisUtterance(msg);
const voiceName = 'Google UK English Female';

// Ensure voices are loaded before selecting
const voices = speechSynthesis.getVoices();

if (voices.length === 0) {
speechSynthesis.onvoiceschanged = () => {
  this.setVoice(speech, voiceName);
  window.speechSynthesis.speak(speech);
};
} else {
this.setVoice(speech, voiceName);
window.speechSynthesis.speak(speech);
}

this.showToastMessage(msg); // ✅ Show toast for anything spoken
},

setVoice(speech, voiceName) {
const voices = speechSynthesis.getVoices();
const selectedVoice = voices.find(voice => voice.name === voiceName);

if (selectedVoice) {
speech.voice = selectedVoice;
} else {
console.warn(`Voice '${voiceName}' not found. Using default voice.`);
}

speech.volume = 1;
speech.rate = 1;
speech.pitch = 1;
},
playChime() {
const audio = new Audio(require("@/assets/audio/complete2.wav"));
audio.volume = 0.5;
audio.play();
},
}
};
</script>

<style scoped>
.progress-bar-ui {
width: 100%;
max-width: 600px;
margin: auto;
text-align: center;
}

.progress-label {
font-size: 1.2rem;
font-weight: bold;
color: #00ffcc;
margin-bottom: 10px;
}

.progress-bar-container {
position: relative;
width: 100%;
height: 40px;
background: rgba(0, 0, 30, 0.7);
border-radius: 14px;
overflow: hidden;
border: 2px solid #00ffcc;
box-shadow: 0 0 10px #00ffcc;
top: 10px;
}

.progress-bar {
height: 100%;
width: 0;
background: linear-gradient(90deg, #00ffcc, #0077ff);
transition: width 0.5s ease-in-out;
box-shadow: 0 0 15px #00ffcc;
}

.progress-text {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
font-size: 1rem;
font-weight: bold;
color: #fff;
text-shadow: 0 0 8px #00ffcc;
}
.ai-toast {
position: fixed;
bottom: 30px;
left: 50%;
transform: translateX(-50%);
background: #001;
color: #00ffcc;
border: 2px solid #00ffcc;
border-radius: 12px;
padding: 12px 20px;
font-size: 16px;
font-family: 'Lato', sans-serif;
box-shadow: 0 0 12px #00ffcc88;
z-index: 99999;
animation: fadeInOut 3s ease forwards;
}

@keyframes fadeInOut {
0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
10% { opacity: 1; transform: translateX(-50%) translateY(0); }
90% { opacity: 1; }
100% { opacity: 0; transform: translateX(-50%) translateY(20px); }
}

.ai-iframe {
border: 2px solid #00ffcc;
border-radius: 12px;
margin-top: 20px;
width: 1630px;
min-height: 700px;
max-height: 100%;
min-width: 100%;
max-width: fit-content;
transition: all 0.3s ease;
z-index: 10;
}

.fullscreen-iframe {
position: fixed !important;
top: 0;
left: 0;
width: 100vw !important;
height: 100vh !important;
margin: 0 !important;
border-radius: 0 !important;
z-index: 9999;
}

.iframe-controls {
margin: 10px 0;
display: flex;
gap: 10px;
justify-content: center;
}

.iframe-controls button {
background: #00ffcc;
color: #000;
font-weight: bold;
border: none;
padding: 8px 16px;
border-radius: 10px;
cursor: pointer;
z-index: 10000;
}

.iframe-controls button:hover {
background: #00ddaa;
}

.bg-content-ai {
/* background-image: url(https://macheenist.com/assets/starsbgv2.png); */
background: #131f25e7;
background-size: cover;
background-position: center center;
background-attachment: fixed;
margin-bottom: 0px;
display: flex;
padding: 40px 40px 40px 40px;
min-height: 90vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media only screen and (max-width: 600px) {
 .bg-content-ai {
background: #131f25e7;
padding: 20px;
min-height: 170vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
} 
}
.step-toggle-ui {
margin-top: 20px;
padding: 10px;
background: #000;
border: 1px solid #00ffcc;
border-radius: 10px;

}

.step-toggle-ui {
width: 100%;
max-width: 1800px;
margin: auto;
padding-block: 20px 20px 20px 20px;
text-align: center;
}

.ai-question {
font-size: 1.5rem;
font-weight: bold;
color: #00ffcc;
margin-top: 20px;
margin-bottom: 20px;
text-align: center;
}

.checkbox-list {
display: grid;
grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
gap: 10px;
justify-content: center;
}

.checkbox-list label {
display: flex;
align-items: center;
justify-content: center;
gap: 8px;
font-weight: bold;
color: #00ffcc;
background: #001;
padding: 10px;
border-radius: 8px;
cursor: pointer;
position: relative;
overflow: hidden;
transition: 0.3s;
border: 2px solid transparent;
}

.checkbox-list label:hover {
border-color: #00ffcc;
box-shadow: 0 0 10px #00ffcc;
}

.checkbox-list input[type="checkbox"] {
display: none;
}

.checkbox-list label .tracker {
width: 12px;
height: 12px;
background: #00ffcc;
border-radius: 50%;
box-shadow: 0 0 8px #00ffcc;
transition: transform 0.3s ease-in-out;
}

.checkbox-list input[type="checkbox"]:checked + .tracker {
transform: scale(1.3);
background: #ff00ff;
box-shadow: 0 0 10px #ff00ff;
}

.suggestion-list {
list-style: none;
padding: 0;
margin-top: 5px;
background: #002;
border: 1px solid #00ffcc;
border-radius: 10px;
max-height: 150px;
overflow-y: auto;
}
.suggestion-list li {
padding: 10px;
cursor: pointer;
}
.suggestion-list li:hover {
background: #003;
}
.ai-assistant-panel {
transition: background 0.5s ease;
background: rgba(10, 10, 30, 0.566);
padding: 20px 60px 20px 60px;
font-size: 18px;
border-radius: 20px;
color: #00ffcc;
font-family: 'Lato', sans-serif;
font-weight: bold;
box-shadow: 0 0 20px #00ffcc66;
max-width: 1800px;
margin: auto;
padding-bottom: 0px;
height: 95vh;
overflow-y: auto;
border: 2px solid #00ffcc;
}
.ai-assistant-panel.listening-bg {
background: rgba(0, 40, 80, 0.9);
}
.ai-assistant-panel.speaking-bg {
background: rgba(0, 80, 40, 0.9);
}
.ai-assistant-panel.thinking-bg {
background: rgba(50, 0, 50, 0.9);
}
.avatar {
text-align: center;
margin-top: 40px;
margin-bottom: 20px;
background: rgb(0, 0, 0);
border-radius: 20px;
padding: 10px 10px 30px 10px;
}
.avatar img {
width: 280px;
border-radius: 50%;
margin-block: 15px;
transition: transform 0.4s ease, filter 0.3s ease;
}
.chat-log-ui {
width: 100%;
max-width: 1400px;
margin: auto;
text-align: center;
}

.chat-header {
font-size: 1.2rem;
font-weight: bold;
color: #00ffcc;
margin-top: 10px;
margin-bottom: 10px;
}

.chat-log {
display: grid;
grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
gap: 10px;
background: rgba(0, 0, 17, 0.107);
padding: 15px;
border-radius: 10px;
margin-top: 30px;
margin-bottom: 30px;
}

.chat-log p {
display: flex;
align-items: center;
justify-content: center;
gap: 8px;
font-weight: bold;
padding: 10px;
border-radius: 8px;
cursor: pointer;
transition: 0.3s;
background: rgba(0, 0, 30, 0.7);
border: 2px solid transparent;
color: #00ffcc;
box-shadow: 0 0 5px #00ffcc;
}

.chat-log p.active {
color: yellow;
border-color: yellow;
box-shadow: 0 0 10px yellow;
}

.chat-log p.completed {
color: #00ffcc;
border-color: #00ffcc;
box-shadow: 0 0 10px #00ffcc;
}

.status-icon {
font-size: 1.2rem;
}
.interaction input {
width: 100%;
padding: 10px;
background: #000;
color: #fff;
border: 1px solid #00ffcc;
border-radius: 10px;
}
.button-row {
display: flex;
gap: 10px;
margin-top: 10px;
}
button {
background: #00ffcc;
border: none;
padding: 10px;
border-radius: 8px;
font-weight: bold;
color: #000;
cursor: pointer;
flex: 1;
}
button:hover {
background: #00ddaa;
}
.step-toggle-ui {
margin-top: 20px;
background: #001;
padding: 10px;
border-radius: 10px;
}
.transcript-box {
background: #111;
border-left: 4px solid #00ffcc;
padding: 10px;
margin-top: 20px;
font-style: italic;
color: #fff;
border-radius: 10px;
font-size: 16px;
font-family: 'Lato', sans-serif;
box-shadow: 0 0 10px #00ffcc66;
}
.transcript-box strong {
color: #00ffcc;
}
</style>
